import { z } from 'zod';

const optionalEmailSchema = z
  .string()
  .refine(
    (value) => value.trim() === '' || z.email().safeParse(value.trim()).success,
    'Podaj poprawny adres e-mail',
  );

const fromNameSchema = z
  .string()
  .max(100, 'Nazwa nadawcy może mieć maksymalnie 100 znaków')
  .refine(
    (value) => !/\p{Cc}/u.test(value),
    'Nazwa nadawcy nie może zawierać enterów ani znaków kontrolnych',
  )
  .refine(
    (value) => !value.includes('@'),
    'Nazwa nadawcy nie może zawierać znaku @',
  );

export const emailSenderSchema = z.object({
  fromEmail: optionalEmailSchema,
  fromName: fromNameSchema,
  replyToEmail: optionalEmailSchema,
});

export type EmailSenderFormData = z.infer<typeof emailSenderSchema>;
